import type { CSSProperties, PropsWithChildren } from "react";

const headerStyles: CSSProperties = {
  fontWeight: "600",
  fontSize: "16px",
  lineHeight: "24px",
};

export function TextAccent({ children }: PropsWithChildren) {
  return <div style={headerStyles}>{children}</div>;
}
